import {
  Component,
  h,
  Prop,
  ComponentInterface,
  Element,
  Method,
} from '@stencil/core';

@Component({
  tag: 'signet-drawer',
  styleUrl: 'signet-drawer.scss',
})
export class SignetDrawer implements ComponentInterface {
  $overlay: HTMLSignetOverlayElement;
  $drawer: HTMLElement;

  @Element() $el: HTMLElement;

  @Prop() position: 'left' | 'right' = 'left';
  @Prop() size: 'sm' | 'md' | 'lg' | 'xl' = 'sm';
  @Prop() headerText: string;
  @Prop() openDrawer = false;

  @Method()
  async hide() {
    this.openDrawer = false;
    await this.$overlay.hide();
  }

  @Method()
  async show() {
    await this.$overlay.show();
    this.openDrawer = true;
  }

  componentDidRender() {
    if (this.openDrawer === false) {
      this.hide();
    }
  }

  overlayHiddenHandler() {
    this.openDrawer = false;
  }

  render() {
    const classes = {
      'signet-drawer': true,
      [`size-${this.size}`]: true,
      [this.position]: true,
      show: this.openDrawer,
    };
    return (
      <signet-overlay
        onHidden={() => this.overlayHiddenHandler()}
        ref={(el) => (this.$overlay = el)}
      >
        <aside class={classes} ref={(el) => (this.$drawer = el)}>
          <header class="drawer-header">
            <h3 class="drawer-title">{this.headerText}</h3>
            <span onClick={() => this.hide()} class="drawer-close">
              <signet-icon icon="close" class="icon" />
            </span>
          </header>
          <div class="drawer-body">
            <slot />
          </div>
        </aside>
      </signet-overlay>
    );
  }
}
